import { render } from "./TradingRatesPage.vue?vue&type=template&id=acf04ef8&scoped=true"
import script from "./TradingRatesPage.vue?vue&type=script&lang=js"
export * from "./TradingRatesPage.vue?vue&type=script&lang=js"

import "./TradingRatesPage.vue?vue&type=style&index=0&id=acf04ef8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf04ef8"]])

export default __exports__